export default __webpack_public_path__ + "static/media/GaugeChart.cb499211.svg";